import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Http, HttpModule, Response, RequestOptions, Headers, URLSearchParams } from '@angular/http';


@Injectable()
export class BreakService {
    private addBreakSubject = new Subject<any>();
    private addBreakEditSubject = new Subject<any>();
    private updateBreakSubject = new Subject<any>();

    constructor(
        private http: Http
    ) { }

    addBreak(data: any) {
        this.addBreakSubject.next(data);
    }

    addBreakEdit(data: any) {
        this.addBreakSubject.next(data);
    }

    updateBreak(data: any) {
        this.updateBreakSubject.next(data);
    }

    onAddBreak() {
        return this.addBreakSubject.asObservable();
    }

    onAddBreakEdit() {
        return this.addBreakEditSubject.asObservable();
    }

    onUpdateBreak() {
        return this.updateBreakSubject.asObservable();
    }
}
